import { Col, Row } from "antd";
import { useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import AssetPath from "../../AssetPath/AssetPath";
import ModalBox from "../../Components/ModalBox/ModalBox";
import PageTitle from "../../Components/PageTitle/PageTitle";
import AgendaList from "../Agenda/AgendaList";
import EventPartners from "../LandingPage/EventPartners";
import SubmitAbstractForm from "../LandingPage/SubmitAbstractForm";
import AnnualConferenceSpeakers from "./AnnualConferenceSpeakers";

export default function AnnualConference2025() {
  const [open, setOpen] = useState();
  // const history = useNavigate;
  return (
    <>
      <PageTitle
        mainTitle="Annual Conference 2025"
        mainDesc="Insights and Impact in Pharma Operations"
        date="March 10-11 2025"
        location="Venetian, Las Vegas"
        breadcrumbItems={[
          {
            name: "Annual Conference 2025",
            path: "/pharma-sos-annual-conference-2025",
          },
        ]}
        image={AssetPath.breadcrumb.agendaImage}
        strokeType="green"
      />

      {/* <img
        src={AssetPath.events.annualConference2025}
        alt="Annual Conference 2025"
        className="w-100"
      /> */}

      <AgendaList />

      <section
        className="jane-speaker d-none position-relative overflow-hidden"
        style={{ backgroundColor: "#f8f8f8" }}
        data-aos="fade-up"
      >
        <div className=" ">
          <div className="row">
            <div className="full-image">
              <img
                src={AssetPath.speakers.janeUrbanFull}
                alt="Jane Urban Vice President, Customer Engagement Operations,
              otsuka-us"
                className="w-100"
              />
            </div>
            <div className="text-field">
              <span className="mb-2 text-secondary font-4 bg-white button-shape">
                Speakers
              </span>
              <h4 className="font-1 mt-2 text-primary font-weight-bold mb-1">
                Jane Urban
              </h4>
              <p className="font-4 text-primary text-ellipsis2 mb-1">
                Vice President, Customer Engagement Operations
              </p>
              <p className="font-4 text-primary text-ellipsis2 mb-3">
                Otsuka Pharmaceutical Companies (U.S)
              </p>
              <p>
                Jane Urban is a seasoned leader in biopharma commercialization,
                specializing in building high-performing teams and integrating
                data, analytics, and omnichannel strategies to enhance customer
                engagement. As VP of Customer Engagement Operations at Otsuka
                Pharmaceuticals, she unifies data, analytics, omnichannel, and
                field operations to optimize customer experience.
              </p>

              <p>
                Previously, Jane was VP of Data, Digital & Technology for Global
                Commercial & Medical at Takeda, where she led US Commercial
                Data, integrated operations post-Shire acquisition, and built
                data capabilities for Entyvio, a key brand. With 15+ years in
                biopharma and 10+ years in team leadership, she has held
                analytics, forecasting, digital marketing, and commercial
                operations roles across pharma and consulting.
              </p>

              <p>
                Jane holds an MBA from Kellogg (Northwestern University) and a
                Biomedical Engineering & Economics degree from Brown University.
              </p>
            </div>
            <div className="image-field position-relative overflow-hidden">
              <img
                src={AssetPath.speakers.janeUrban}
                alt="Jane Urban Vice President, Customer Engagement Operations, otsuka-us"
                className="w-100"
              />
            </div>
            {/* </Carousel> */}
          </div>
        </div>
      </section>

      <section
        className="spacing d-none "
        style={{ background: "linear-gradient(45deg, #1f1e46, #213c6d)" }}
      >
        <div className="container">
          <Row
            gutter={[
              { xs: 10, sm: 16, md: 24, lg: 30 },
              { xs: 10, sm: 16, md: 24, lg: 30 },
            ]}
            justify="center"
            align="middle"
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 12 }}
              md={{ span: 10 }}
              lg={{ span: 10 }}
              className="text-center"
            >
              <img
                src={AssetPath.events.annualConference2025}
                alt="Annual Conference 2025 Venetian, Las Vegas"
                className="w-100 rounded"
              />
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 12 }}
              md={{ span: 10 }}
              lg={{ span: 10 }}
            >
              <div className="paddstart-30">
                <h4 className="title text-white">Annual Conference 2025</h4>
                <p className="text-white">
                  Join us at The Venetian Las Vegas for a day of insights,
                  networking, and cutting-edge presentations. Ideal for
                  professionals seeking to stay ahead in the evolving pharma
                  landscape!
                </p>
                <a
                  href="https://www.eventbrite.com/e/pharma-sos-annual-conference-tickets-1077484417899"
                  target="_blank"
                  rel="noreferrer"
                  className="ant-btn ant-btn-secondary"
                >
                  Register Now
                  <FiArrowUpRight size={16} className="ms-2" />
                </a>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <AnnualConferenceSpeakers />

      {/* <CTA
        subTitle="Submit Your Abstract"
        desc="Present your cutting-edge insights at Innovate Pharma 2024. Engage with industry leaders, contribute to pivotal discussions, and collaborate with global experts!"
        label="Submit"
        noImage
        onClick={() => history("/abstract-submission")}
      /> */}

      <EventPartners className="spacing-bottom" />

      <ModalBox
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        footer={null}
        width={900}
      >
        <SubmitAbstractForm />
      </ModalBox>
    </>
  );
}
